$(document).ready(function() {
  $('#site-overlay').on('click', function(e) {
    e.preventDefault();
    $('body').removeClass('menu-active');
    $('.menu-trigger').removeClass('open');
  })
});
